class ReviewForm extends HTMLElement {
  connectedCallback() {
    this.workerUrl = this.dataset.workerUrl;

    this.panels = {
      loading: this.querySelector('[data-review-loading]'),
      missingLink: this.querySelector('[data-review-missing-link]'),
      invalidLink: this.querySelector('[data-review-invalid-link]'),
      thankYou: this.querySelector('[data-review-thank-you]'),
      content: this.querySelector('[data-review-content]'),
    };
    this.form = this.querySelector('[data-review-submit-form]');
    this.errorEl = this.querySelector('[data-review-error]');

    const params = new URLSearchParams(window.location.search);
    this.product = params.get('product');
    this.order = params.get('order');
    this.sig = params.get('sig');

    if (!this.product || !this.order || !this.sig || !this.workerUrl) {
      this.showPanel('missingLink');
      return;
    }

    this.loadProduct();
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  showPanel(name) {
    for (const [key, panel] of Object.entries(this.panels)) {
      if (panel) panel.hidden = key !== name;
    }
  }

  async loadProduct() {
    try {
      const response = await fetch(`/products/${this.product}.js`);
      if (!response.ok) throw new Error('Product not found');
      const product = await response.json();

      const titleEl = this.querySelector('[data-review-product-title]');
      const imageEl = this.querySelector('[data-review-product-image]');
      if (titleEl) titleEl.textContent = product.title.split(' | ')[0];
      if (imageEl) {
        if (product.featured_image) {
          const sizeSep = product.featured_image.includes('?') ? '&' : '?';
          imageEl.src = product.featured_image + sizeSep + 'width=400';
          imageEl.alt = product.title;
        } else {
          imageEl.remove();
        }
      }
    } catch (error) {
      const imageEl = this.querySelector('[data-review-product-image]');
      if (imageEl) imageEl.remove();
    } finally {
      this.showPanel('content');
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    this.errorEl.hidden = true;

    const formData = new FormData(this.form);
    const submitButton = this.form.querySelector('button[type="submit"]');
    const label = submitButton.querySelector('[data-submit-label]');
    const originalLabel = label.textContent;

    submitButton.disabled = true;
    label.textContent = label.dataset.submittingLabel;

    try {
      const response = await fetch(this.workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product: this.product,
          order: this.order,
          sig: this.sig,
          rating: Number(formData.get('rating')),
          author: formData.get('author'),
          body: formData.get('body'),
        }),
      });

      if (response.status === 403) {
        this.showPanel('invalidLink');
        return;
      }

      if (!response.ok) throw new Error('Submit failed');

      this.showPanel('thankYou');
    } catch (error) {
      this.errorEl.hidden = false;
      submitButton.disabled = false;
      label.textContent = originalLabel;
    }
  }
}

customElements.define('review-form', ReviewForm);
